export interface LoadTypeRenderConfig {
  textScale: number
  showUnitsInScene: boolean
  showUnitInNewLine: boolean
}

export interface LineLoadRenderConfig extends LoadTypeRenderConfig {
  /** Width (m) of the largest line load value in the 2D floorplan; others scale proportionally. */
  floorplanMaxWidth: number
}

export interface PointLoadRenderConfig extends LoadTypeRenderConfig {
  /** Diameter (m) of the point load circle in the 2D floorplan. */
  floorplanDiameter: number
}

/**
 * Size of the inner forces envelope in the 3D scene: each member's envelope is scaled so that its
 * largest value is drawn with this ordinate.
 */
export interface InnerForcesEnvelopeRenderConfig {
  /** Largest ordinate (m), shared by moments and shear forces. */
  maxOrdinate: number
}

export interface LoadRenderConfig {
  lineLoads: LineLoadRenderConfig
  pointLoads: PointLoadRenderConfig
  innerForcesEnvelope: InnerForcesEnvelopeRenderConfig
}

export const defaultLoadRenderConfig: LoadRenderConfig = {
  lineLoads: {
    textScale: 0.07,
    showUnitsInScene: true,
    showUnitInNewLine: false,
    floorplanMaxWidth: 0.4,
  },
  pointLoads: {
    textScale: 0.07,
    showUnitsInScene: true,
    showUnitInNewLine: true,
    floorplanDiameter: 0.2,
  },
  innerForcesEnvelope: {
    maxOrdinate: 3,
  },
}

export const mergeLoadRenderConfig = (
  current: LoadRenderConfig,
  persisted?: Partial<LoadRenderConfig>,
): LoadRenderConfig => ({
  lineLoads: {
    ...current.lineLoads,
    ...persisted?.lineLoads,
  },
  pointLoads: {
    ...current.pointLoads,
    ...persisted?.pointLoads,
  },
  innerForcesEnvelope: {
    ...current.innerForcesEnvelope,
    ...persisted?.innerForcesEnvelope,
  },
})
